import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import Field from "designV2/components/Field";
import Button from "designV2/components/Button";
import AuthShell, { go, readableError, startCodeTimer } from "./auth/AuthShell";

const GET_CODE = gql`
  mutation getAdminForgotPasswordCode($emailOrPhoneNumber: String!) {
    getAdminForgotPasswordCode(emailOrPhoneNumber: $emailOrPhoneNumber) {
      phoneForgotPasswordCodeExpireTime
    }
  }
`;

/**
 * ForgetPassword - ask for a reset code.
 *
 * Takes either identifier because sign-in does; the server works out
 * which it was given and sends the code the matching way.
 */
const ForgetPassword = (props) => {
  const history = props.history;

  const [identifier, setIdentifier] = useState("");
  const [identifierError, setIdentifierError] = useState("");
  const [sending, setSending] = useState(false);

  const [getAdminForgotPasswordCode] = useMutation(GET_CODE);

  const onSubmit = (event) => {
    if (event) event.preventDefault();
    if (sending) return;

    const value = identifier.trim();
    if (!value) {
      setIdentifierError("Enter your email or phone number");
      return;
    }
    setIdentifierError("");

    setSending(true);
    getAdminForgotPasswordCode({ variables: { emailOrPhoneNumber: value } })
      .then((res) => {
        window.localStorage.setItem("emailForgetPassword", value);
        startCodeTimer(res.data.getAdminForgotPasswordCode.phoneForgotPasswordCodeExpireTime);
        go(history, "/enterForgetPasswordCode");
      })
      .catch((error) => {
        setSending(false);
        setIdentifierError(readableError(error));
      });
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We will send a five-digit code to confirm it is you."
      brandTitle="Locked out?"
      brandText="It happens. Confirm the email or phone number on your account and you can set a new password straight away."
    >
      <form className="authForm" onSubmit={onSubmit}>
        <Field
          label="Email or phone number"
          htmlFor="forgotIdentifier"
          error={identifierError}
        >
          <input
            id="forgotIdentifier"
            className="dsInput"
            type="text"
            autoComplete="username"
            autoFocus
            value={identifier}
            onChange={(event) => setIdentifier(event.target.value)}
          />
        </Field>

        <div className="authActions">
          {/* This used to run the mutation on the way out, so going back
              also fired off a code nobody asked for. */}
          <Button variant="secondary" size="lg" onClick={() => go(history, "/login")}>
            Back
          </Button>
          <Button type="submit" variant="primary" size="lg" loading={sending}>
            {sending ? "Sending" : "Send code"}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
};

export default ForgetPassword;
